import { render, staticRenderFns } from "./EmpzoneColContentModal.vue?vue&type=template&id=4bf475d9&"
import script from "./EmpzoneColContentModal.vue?vue&type=script&lang=js&"
export * from "./EmpzoneColContentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bf475d9')) {
      api.createRecord('4bf475d9', component.options)
    } else {
      api.reload('4bf475d9', component.options)
    }
    module.hot.accept("./EmpzoneColContentModal.vue?vue&type=template&id=4bf475d9&", function () {
      api.rerender('4bf475d9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/empzone/colContent/modules/EmpzoneColContentModal.vue"
export default component.exports